export function Spinner({ size = 16, label = 'Loading' }) {
  const px = typeof size === 'number' ? `${size}px` : String(size);
  return (
    <span className="spinner" role="status" aria-label={label} style={{ width: px, height: px }} />
  );
}

export function LoadingBar({ label = 'Loading' }) {
  return <div className="loading-bar" role="status" aria-label={label} />;
}


